import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_3 = { class: "cardbody" }
const _hoisted_4 = { class: "flex flex-row-reverse items-center" }
const _hoisted_5 = { class: "flex flex-row-reverse items-center" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_10 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_11 = { class: "formcontainer flex flex-col" }
const _hoisted_12 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_13 = { class: "col-md-6 w-6/12" }
const _hoisted_14 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_15 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_16 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_17 = { class: "col-md-6 w-6/12" }
const _hoisted_18 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_19 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_20 = { class: "row grid grid-cols-2" }
const _hoisted_21 = { class: "w-full upperspacing leftspacing" }
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_24 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_25 = {
  key: 0,
  class: "w-full upperspacing"
}
const _hoisted_26 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_27 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_28 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_29 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_30 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_31 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_32 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_33 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_34 = {
  key: 1,
  class: "invalid-feedback"
}
const _hoisted_35 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_36 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_37 = {
  key: 1,
  class: "invalid-feedback"
}
const _hoisted_38 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_39 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_40 = {
  key: 1,
  class: "invalid-feedback"
}
const _hoisted_41 = { class: "buttonposition flex justify-center items-center mt-2 mb-4 mx-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_dropdown = _resolveComponent("dropdown")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "title" }, "System Risk", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["flex", _ctx.systemData.length == 0?'btndisabled pointer-events-none':'filterButton']),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              (_ctx.systemData.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7)),
              _cache[10] || (_cache[10] = _createTextVNode(" Filters "))
            ], 2)
          ])
        ])
      ])
    ]),
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "mt-3 text-xs" }, [
      _createElementVNode("div", null, " Identify, manage, and monitor risks in systems by maintaining details such as owners, vendors, and related information. ")
    ], -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_newTable, {
        tableRowData: _ctx.systemData,
        headersData: _ctx.headers1,
        openPopup: false,
        navigate: true,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.popUp==true)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          class: "system",
          popUp: _ctx.popUp
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _cache[13] || (_cache[13] = _createElementVNode("h1", null, "System", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCancelbtn('close')))
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "controllabel" }, "System Name", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(["inputboxstyling", {
                                            'is-invalid': _ctx.v$.system.systemName.$error
                                        }]),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.system.systemName) = $event)),
                            placeholder: "System Name"
                          }, null, 2), [
                            [
                              _vModelText,
                              _ctx.system.systemName,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.system.systemName.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                (_ctx.v$.system.systemName.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-md-6 w-6/12 leftspacing" }, [
                          _createElementVNode("label", { class: "controllabel" }, "Owned Entity"),
                          _createElementVNode("div")
                        ], -1))
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(["inputboxstyling", {
                                            'is-invalid borderRed': _ctx.v$.system.description.$error,
                                        }]),
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.system.description) = $event)),
                            placeholder: "Description"
                          }, null, 2), [
                            [
                              _vModelText,
                              _ctx.system.description,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.system.description.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                (_ctx.v$.system.description.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-md-6 w-6/12 leftspacing" }, [
                          _createElementVNode("label", { class: "controllabel" }, "Managed By"),
                          _createElementVNode("div")
                        ], -1))
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-md-6 upperspacing" }, [
                          _createElementVNode("label", { class: "controllabel" }, "Owner"),
                          _createElementVNode("div")
                        ], -1)),
                        _createElementVNode("div", _hoisted_21, [
                          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "controllabel" }, "Public Facing?", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["inputboxstyling", {
                                            'is-invalid': _ctx.v$.system.publicFacing.$error
                                        }]),
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.system.publicFacing) = $event))
                          }, [
                            _cache[18] || (_cache[18] = _createElementVNode("option", {
                              value: "",
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, "Please select one", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yesNo, (response) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: response,
                                value: response.id
                              }, _toDisplayString(response.value), 9, _hoisted_22))
                            }), 128))
                          ], 2), [
                            [_vModelSelect, _ctx.system.publicFacing]
                          ]),
                          (_ctx.v$.system.publicFacing.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                (_ctx.v$.system.publicFacing.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.system.publicFacing == '1')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "controllabel" }, [
                                _createTextVNode("Add "),
                                _createElementVNode("span", { class: "text-xs" }, "(URL / IP Address / Domain Name)")
                              ], -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["inputboxstyling", {
                                            'is-invalid': _ctx.v$.system.add.$error
                                        }]),
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.system.add) = $event)),
                                placeholder: "Add"
                              }, null, 2), [
                                [
                                  _vModelText,
                                  _ctx.system.add,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.system.add.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    (_ctx.v$.system.add.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full upperspacing", {'leftspacing':_ctx.system.publicFacing == '1'}])
                        }, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", { class: "controllabel" }, "Hosting type", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["inputboxstyling", {
                                            'is-invalid': _ctx.v$.system.hostingType.$error
                                        }]),
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.system.hostingType) = $event))
                          }, _cache[21] || (_cache[21] = [
                            _createElementVNode("option", {
                              value: "",
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, "Please select one", -1),
                            _createElementVNode("option", { value: "on-premise" }, "On-premise", -1),
                            _createElementVNode("option", { value: "data-center" }, "Data center", -1),
                            _createElementVNode("option", { value: "cloud" }, "Cloud", -1)
                          ]), 2), [
                            [_vModelSelect, _ctx.system.hostingType]
                          ]),
                          (_ctx.v$.system.hostingType.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                (_ctx.v$.system.hostingType.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["col-md-6 w-full upperspacing", {'leftspacing':_ctx.system.publicFacing != '1'}])
                        }, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", { class: "controllabel" }, "Provider", -1)),
                          _createVNode(_component_dropdown, {
                            dataprops: _ctx.selectedCategory,
                            inputValue: _ctx.system.hostingProvider,
                            placeholderValue: 'Provider',
                            onName: _ctx.getCategories,
                            error: _ctx.v$.system.hostingProvider.$error
                          }, null, 8, ["dataprops", "inputValue", "onName", "error"]),
                          (_ctx.v$.system.hostingProvider.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (_ctx.v$.system.hostingProvider.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["col-md-6 w-full upperspacing", {'leftspacing':_ctx.system.publicFacing == '1'}])
                        }, [
                          _cache[24] || (_cache[24] = _createElementVNode("label", { class: "controllabel" }, "Country", -1)),
                          _createVNode(_component_dropdown, {
                            dataprops: _ctx.selectedCategory,
                            inputValue: _ctx.system.country,
                            placeholderValue: 'Country',
                            onName: _ctx.getCategories,
                            error: _ctx.v$.system.country.$error
                          }, null, 8, ["dataprops", "inputValue", "onName", "error"]),
                          (_ctx.v$.system.country.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                (_ctx.v$.system.country.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Required"))
                                  : (_ctx.v$.system.country.required && _ctx.v$.system.country.alphabet.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Country is Invalid"))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["col-md-6 w-full upperspacing", {'leftspacing':_ctx.system.publicFacing != '1'}])
                        }, [
                          _cache[25] || (_cache[25] = _createElementVNode("label", { class: "controllabel" }, "State", -1)),
                          _createVNode(_component_dropdown, {
                            dataprops: _ctx.selectedCategory,
                            inputValue: _ctx.system.state,
                            placeholderValue: 'State',
                            onName: _ctx.getCategories,
                            error: _ctx.v$.system.state.$error
                          }, null, 8, ["dataprops", "inputValue", "onName", "error"]),
                          (_ctx.v$.system.state.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                (_ctx.v$.system.state.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Required"))
                                  : (_ctx.v$.system.state.required && _ctx.v$.system.state.alphabet.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, "State is Invalid"))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["col-md-6 w-full upperspacing", {'leftspacing':_ctx.system.publicFacing == '1'}])
                        }, [
                          _cache[26] || (_cache[26] = _createElementVNode("label", { class: "controllabel" }, "City", -1)),
                          _createVNode(_component_dropdown, {
                            dataprops: _ctx.selectedCategory,
                            inputValue: _ctx.system.city,
                            placeholderValue: 'City',
                            onName: _ctx.getCategories,
                            error: _ctx.v$.system.city.$error
                          }, null, 8, ["dataprops", "inputValue", "onName", "error"]),
                          (_ctx.v$.system.city.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                (_ctx.v$.system.city.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, "Required"))
                                  : (_ctx.v$.system.city.required && _ctx.v$.system.city.alphabet.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, "City is Invalid"))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 2)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onCancelbtn(_ctx.system._id)))
                  }, "Reset", 2),
                  (!_ctx.system._id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["btnprimary", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addOrUpdate(_ctx.system, 20005)))
                      }, "Save", 2))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: _normalizeClass(["btnprimary", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addOrUpdate(_ctx.system, 20005)))
                      }, "Update", 2))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}